import * as Popover from "@radix-ui/react-popover";
import { useAppDispatch } from "hooks/useAppDispatch";
import { useAppSelector } from "hooks/useAppSelector";
import { useCallback } from "react";
import { setOpenComment } from "store/slices/openComment";

export const AddCommentPopoverRoot = ({
  contentId,
  children,
}: {
  contentId: string;
  children: React.ReactNode;
}) => {
  const dispatch = useAppDispatch();
  const openComment = useAppSelector((state) => state.openComment.openComment);
  const open = openComment === contentId;

  const onOpenChange = useCallback(
    (isOpen: boolean) => {
      dispatch(setOpenComment(isOpen ? contentId : null));
    },
    [contentId, dispatch]
  );

  return (
    <Popover.Root open={open} onOpenChange={onOpenChange}>
      {children}
    </Popover.Root>
  );
};
